import React, { useState } from 'react';
import { cn } from '../../utils/cn';
import { Mail } from 'lucide-react';
function FormInput({
  label,
  error,
  multiline = false,
  className,
  id,
  ...props
}: {
  label: string;
  error?: string;
  multiline?: boolean;
  className?: string;
  id?: string;
} & React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>) {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');
  const base = ['w-full bg-brand-gray-900 text-brand-white px-4 py-3', 'border rounded-sm transition-colors duration-200', 'placeholder:text-brand-gray-500', 'focus:outline-none focus:border-brand-teal focus:ring-1 focus:ring-brand-teal', error ? 'border-red-500/60 focus:border-red-500 focus:ring-red-500' : 'border-brand-gray-700'].join(' ');
  return <div className="w-full flex flex-col gap-2" data-id="element-321">
      <label htmlFor={inputId} className="text-xs font-bold text-brand-gray-300 uppercase tracking-widest" data-id="element-322">
        {label}
      </label>
      {multiline ? <textarea id={inputId} className={cn(base, 'min-h-[120px] resize-y', className)} aria-invalid={!!error} aria-describedby={error ? `${inputId}-error` : undefined} {...props as React.TextareaHTMLAttributes<HTMLTextAreaElement>} data-id="element-323" /> : <input id={inputId} className={cn(base, className)} aria-invalid={!!error} aria-describedby={error ? `${inputId}-error` : undefined} {...props as React.InputHTMLAttributes<HTMLInputElement>} data-id="element-324" />}
      {error && <span id={`${inputId}-error`} role="alert" className="text-xs text-red-400 mt-0.5" data-id="element-325">
          {error}
        </span>}
    </div>;
}
const btnClasses = 'inline-flex items-center justify-center font-semibold uppercase tracking-wider transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black active:scale-[0.97] active:transition-none clip-edges bg-brand-teal text-brand-white border border-transparent hover:bg-brand-teal-light px-8 py-4 text-base gap-2.5';
export function ContactForm() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  }
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitted(true);
  }
  return <div className="lg:col-span-3" data-id="element-326">
      <h2 className="text-2xl font-bold text-brand-white uppercase tracking-wide mb-8" data-id="element-327">
        Send Us a Message
      </h2>

      {submitted ? <div className="p-8 border border-brand-teal/30 bg-brand-teal/5 text-center" data-id="element-328">
          <Mail className="w-12 h-12 text-brand-teal mx-auto mb-4" data-id="element-329" />
          <h3 className="text-xl font-bold text-brand-white uppercase mb-2" data-id="element-330">
            Message Sent
          </h3>
          <p className="text-brand-gray-400" data-id="element-331">
            Thank you for reaching out. We will get back to you as soon as
            possible.
          </p>
        </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-332">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-333">
            <FormInput label="Full Name" name="name" placeholder="Your name" value={form.name} onChange={handleChange} required data-id="element-334" />
            <FormInput label="Email Address" name="email" type="email" placeholder="you@example.com" value={form.email} onChange={handleChange} required data-id="element-335" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-336">
            <FormInput label="Phone Number" name="phone" type="tel" placeholder="(555) 000-0000" value={form.phone} onChange={handleChange} data-id="element-337" />
            <FormInput label="Subject" name="subject" placeholder="How can we help?" value={form.subject} onChange={handleChange} required data-id="element-338" />
          </div>
          <FormInput label="Message" name="message" multiline placeholder="Tell us about your needs..." value={form.message} onChange={handleChange} required data-id="element-339" />
          <button type="submit" className={btnClasses} data-id="element-340">
            Send Message
          </button>
        </form>}
    </div>;
}